export default __webpack_public_path__ + "61ba66cbd52e5b20ec9be90be455c372.png";